<template>
    <div>
        <div class="page-head">
            <a-icon @click="$router.go(-1)" type="left-square" theme="filled"/>
            <a-breadcrumb>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">拓客利器</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">名片访客</a></a-breadcrumb-item>
            </a-breadcrumb>
        </div>

        <div class="clue-search">
            <div class="sx1" :hidden="select1">
                <div class="left" >
                    <a-select style="width: 120px" allowClear @change="handleChange" placeholder="是否转换">
                        <a-select-option value="jack">
                            不限
                        </a-select-option>
                        <a-select-option value="lucy">
                            已转线索
                        </a-select-option>
                        <a-select-option value="disabled" >
                            未转线索
                        </a-select-option>
                    </a-select>

                    <a-select style="width: 120px" allowClear @change="handleChange" placeholder="是否有手机号" :showArrow="show">
                        <a-select-option value="jack">
                            不限
                        </a-select-option>
                        <a-select-option value="lucy">
                            是
                        </a-select-option>
                        <a-select-option value="lucy">
                            否
                        </a-select-option>
                    </a-select>

                    <a-select style="width: 120px" allowClear @change="handleChange" placeholder="意向度" :showArrow="show">
                        <div slot="dropdownRender" slot-scope="menu" class="yxselect">
                            <div class="yxinput">
                                <a-input placeholder="输入整数" /><span>%</span><span>—</span><a-input placeholder="输入整数" /><span>%</span>
                            </div>
                            <div style="text-align:right;padding-top:12px;border-top:1px solid #d8d8d8;margin-top:12px">
                                <a-button :size="size">取消</a-button>
                                <a-button type="primary" :size="size">确定</a-button>
                            </div>
                        </div>
                    </a-select>

                    <a-select style="width: 120px" allowClear @change="handleChange" placeholder="最后活跃时间" :showArrow="show" :dropdownMatchSelectWidth="width">
                        <a-icon slot="suffixIcon" type="calendar" />
                        <div slot="dropdownRender" slot-scope="menu" class="dateselect">
                            <ul class="date">
                              <li class="dateed">全部</li>
                              <li>今天</li>
                              <li>昨天</li>
                              <li>过去7天</li>
                              <li>过去30天</li>  
                            </ul>
                            <div style="text-align:center;padding-top:12px;border-top:1px solid #d8d8d8;margin-top:12px">
                                <a-range-picker @change="onChange">
                                    <span>自定义 </span>
                                </a-range-picker>
                            </div>
                        </div>
                    </a-select>

                    <a-select style="width: 120px" allowClear @change="handleChange" placeholder="创建日期" :showArrow="show" :dropdownMatchSelectWidth="width">
                        <a-icon slot="suffixIcon" type="calendar" />
                        <div slot="dropdownRender" slot-scope="menu" class="yxselect">
                            <div class="yxinput">
                                <a-input placeholder="输入整数" /><span>%</span><span>—</span><a-input placeholder="输入整数" /><span>%</span>
                            </div>
                            <div style="text-align:center;padding-top:12px;border-top:1px solid #d8d8d8;margin-top:12px">
                                <a-range-picker @change="onChange">
                                    <span>自定义 </span>
                                </a-range-picker>
                            </div>
                        </div>
                    </a-select>


                </div>
                <a href="javascript:;" class="right" @click="showsx">
                    清空条件
                </a>
            </div>
        </div>

        <div class="clue-list cardlist">
            <div class="top-tool ">
                <span>当前条件下,共筛选出 0 位访客</span>
                <a-input-group compact>
                    <a-select default-value="1">
                        <a-select-option value="1">
                        手机号
                        </a-select-option>
                        <a-select-option value="2">
                        姓名
                        </a-select-option>
                    </a-select>
                     <a-input-search placeholder="input search text" style="width: 200px" @search="onSearch" />
                </a-input-group>
            </div>
            <a-table :columns="columns" :data-source="data">
                <span slot="action" slot-scope="text, record">
                   
                    <a href="javascript:;">查看详情</a>
                    <a href="javascript:;">查看线索</a>
                </span>
            </a-table>
        </div>
    </div>
</template>
<script>
const columns= [
  {
    title: '访客',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: '手机号',
    dataIndex: 'phone',
    key: 'phone',

  },
  {
    title: '意向度',
    dataIndex: 'yx',
    key: 'yx',
  },
  {
    title: '转化状态',
    dataIndex: 'type',
    key: 'type',
    width: '120px',
  },
  {
    title: '最后活跃是时间',
    dataIndex: 'time',
    key: 'time',
  },
  {
    title: '创建时间',
    dataIndex: 'date',
    key: 'date',
  },
    {
    title: '操作',
    key: 'action',
    scopedSlots: { customRender: 'action' },
  },
]
const data= [
  {
    name: '姓名',
    phone: 'name',
    key: 'name',
    fixed: 'left',
  },
  {
    name: '标签',
    phone: 'type',
    key: 'type',
    width: '120px',
  },
]
export default {
    data(){
        return{
            show:true,
            size:'small',
            width:false,
            columns,
            data
        }
    },
    methods:{
        handleChange(){

        },
        showsx(){

        },
        onChange(){

        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/toker/card.vue